import React, { useEffect, useState, useRef } from "react"
import axios from "axios"
import { useDispatch, useSelector } from "react-redux"
import { trackCustomEvent } from "gatsby-plugin-google-analytics"

import * as s from "./Upsell.module.scss"

import { Cta } from "../../../common/cta/Cta"
import toBase64String from "../../../../utils/toBase64String"
import { formatShopifyPrice } from "../../../../utils/formatShopifyPrice"
import useOnClickOutside from "../../../../hooks/click-outside"
import { addLineItemsToCart } from "@ducks/cartSlice"
import { setAppState } from "../../../../ducks/appSlice"

import { setState, closeUpsell } from "../../../../ducks/sidebarSlice"

export const UpSell = () => {
  const dispatch = useDispatch()
  const _upsellModal = useRef()
  const closeModal = () => {
    dispatch(closeUpsell())
    dispatch(setAppState({ pageLocked: false }))
  }
  useOnClickOutside(_upsellModal, () => closeModal())
  const [recommendedProducts, setRecommendedProducts] = useState([])
  const [addedItems, setAddedItems] = useState([])
  const [continueDisabled, setContinueDisabled] = useState(false)
  const [idsOfProductsAdded, setIdsOfProductsAdded] = useState([])

  const cart = useSelector(state => state.cart.cart)
  const visible = useSelector(state => state.sidebar.upsellIsVisible)

  useEffect(() => {
    const doc = document.getElementsByTagName("html")[0]
    if (visible) {
      doc.style.cssText =
        "touch-action: none; overscroll-behavior: none; -webkit-overflow-scrolling: auto; overflow: hidden;"
    } else {
      doc.style.cssText = ""
    }
  }, [])

  useEffect(() => {
    if (!cart.lines || !cart.lines.edges[0]) return

    const productId = cart.lines.edges[0].node.merchandise.product.id

    const variantId = productId.includes("gid://shopify/")
      ? toBase64String(productId)
      : productId

    if (recommendedProducts.length < 1) {
      fetchData(variantId)
      dispatch(setAppState({ pageLocked: true }))
    }
  }, [cart])

  if (!cart) {
    return <span></span>
  }

  const fetchData = async productId => {
    try {
      const shopifyRes = await axios.post(`/.netlify/functions/recommended`, {
        productId,
      })
      console.log(shopifyRes, "data")

      const recomendations = shopifyRes.data.filter(item => {
        return (
          item.productType !== "Personalised" && item.variants.nodes.length < 2
        )
      })
      if (recomendations.length < 1) {
        // openCheckout()
      } else {
        setRecommendedProducts(recomendations.slice(0, 3))
        console.log(recomendations, "recomendations")
      }
    } catch (e) {
      // openCheckout()
    }

    dispatch(
      setState({
        sidebarIsVisible: false,
      }),
    )
  }

  const encodeShopifyProductId = id => {
    const encoded = btoa(id)
    return encoded
  }

  const handleAddToCart = product => {
    let cartId = cart.id
    setAddedItems([...addedItems, product.id])
    console.log(encodeShopifyProductId(product.variants.nodes[0].id), "id")

    dispatch(
      addLineItemsToCart({
        product: {
          shopifyId: encodeShopifyProductId(product.variants.nodes[0].id),
          quantity: 1,
        },
        cartId,
      }),
    )
  }

  const openCheckout = () => {
    setContinueDisabled(true)
    dispatch(setAppState({ pageLocked: false }))
    let gaLinkerParam = null
    window.ga(function (tracker) {
      gaLinkerParam = tracker.get("linkerParam")
    })
    const queryStringSuffix = gaLinkerParam ? `&${gaLinkerParam}` : ""
    window.location.href = `${cart.checkoutUrl}${queryStringSuffix}`
  }

  return (
    <div className={s.UpSell}>
      <div
        ref={_upsellModal}
        className={`${s.UpSellContent} ${
          recommendedProducts.length > 0 ? s.UpSellContent___in : ""
        }`}
      >
        <div className={s.UpSellContent__header}>
          <h3>While you're here?</h3>
        </div>
        <div className={s.UpSellContent__products}>
          <div className={s.ProductList}>
            {recommendedProducts.map((product, i) => {
              return (
                <div
                  className={s.ProductList__product}
                  key={i}
                  onClick={() => {
                    trackCustomEvent({
                      category: "Cart",
                      action: "upsell product click",
                    })
                    handleAddToCart(product)
                    setIdsOfProductsAdded([...idsOfProductsAdded, i])
                  }}
                >
                  <div
                    className={`${s.ProductList__image} ${
                      idsOfProductsAdded.includes(i)
                        ? s.ProductList__imageAdded
                        : ""
                    }`}
                    style={{
                      backgroundImage: `url(${
                        product.variants.nodes[0].image.src
                          ? product.variants.nodes[0].image.src
                          : product.featuredImage.src
                      })`,
                    }}
                  />
                  <div className={s.ProductList__title}>
                    <span>
                      {product.variants.nodes.length > 1
                        ? product.variants.nodes[0].title
                        : product.title}
                    </span>
                  </div>
                  <div className={s.ProductList__price}>
                    <span>
                      {formatShopifyPrice(
                        product.variants.nodes[0].price.amount,
                      )}
                    </span>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
        <div className={s.UpSellContent__footer}>
          <div className={s.UpSellContent__footer___container}>
            <span className={s.UpSellContent__footer___containerOr}> OR</span>
            <Cta
              title={"Continue to checkout"}
              onClick={openCheckout}
              className={s.UpSellContent__Cta}
              disabled={continueDisabled}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
